import { adminPrefix } from "../../constants";

export const projectsApis = {
  FETCH_PROJECTS: adminPrefix + "projects",
  CREATE_PROJECT: adminPrefix + "project/create",
  UPDATE_PROJECT: adminPrefix + "project/update",
  DELETE_PROJECT: adminPrefix + "project/delete",
  UPDATE_PROJECT_STATUS: adminPrefix + "project/update-status",
};
